


  
  

  var faBernand = {
    prefix: 'fak',
    iconName: 'bernand',
    icon: [
      512,
      512,
      [],
      'e013',
      
      'M130.8 80.3l46.3 0-1.3-77.1c.1-1.6 1.4-2.9 3-3s3 1.2 3.2 2.8l4.4 77.4 125.7 0 0-76.9c.1-1.4 1.2-2.4 2.5-2.5s2.5 1 2.7 2.3l4.9 77.1 44.8 0c1.7 0 3.3 .8 4.3 2.2l19.8 27.4 9.8 43c.5 2.2 2.4 3.9 4.7 4.1l17.4 1.8c2.7 .3 4.7 2.5 4.8 5.2l1.2 68.4c0 2.7-2 5-4.7 5.4l-19 2.2c-2.1 .2-3.9 1.7-4.5 3.8l-18.2 60.4c-.3 1.1-1.4 1.9-2.6 1.9l-65.8 0c-1.5 0-2.7 1.2-2.7 2.7l0 4.5 5.3 0c2.9 0 5.3 2.4 5.2 5.3l0 1.1c-.2 6.1-.5 12.8 .7 13.8l3.6 3.2 .2 .1c4 3.6 6.1 5.5 8.7 7.4 1 .7 2.3 .6 3.2-.3 1.7-1.6 3.7-2.8 9.1-1 .6 .2 1.1 .5 1.6 .9 18.1 15.6 31.4 36.7 40.1 58.1l.3 .8c1.5 3.9 2.8 7.5 .2 11.5-2.4 3.8-11.2 3.8-16.8 3.2-1.4-.2-2.6-.9-3.4-1.9-15-19.3-28-36.3-34-59.2-.1-.2-.2-.3-.4-.4s-.4 0-.5 .1c-4.3 3.2-7.9 4.8-12.3 6.4-1 .3-1.7 1.3-1.8 2.3l-4.4 63.6c-.2 2.8-2.4 4.9-5.2 5l-4.2 .1c-2 0-3.8 2.3-3.5 4.2 .7 5.1 1.6 13.5 1.9 19.1 .5 6.9 3.3 9.3 4.8 10.5 .2 .2 .4 .4 .6 .5 1.1 1.1 2.9 3.2 6.4 8.8 1.8 2.9 2.3 6 2.4 8.4 0 1.7 1.3 3.3 3.1 3.3l4.6 0c1.2 0 2.2 .7 2.5 1.9 2 7.2 3 14.5 3.3 18.9 0 .7-.2 1.4-.7 1.9s-1.2 .8-1.9 .8l-57.1 0c-.8 0-1.6-.4-2.1-1s-.7-1.5-.5-2.3c1.7-6.3 4-15 4.2-16.4l.2-2.3c.3-3.5 .8-9.4 1.6-10.2s7-9 10.5-13.5c.3-.4 .5-1 .5-1.5l1.2-28.2c0-.7-.2-1.4-.7-2s-1.2-.8-1.9-.8l-76.6 0c-1.5 0-2.8 1.3-2.6 2.8 .9 12.7 2.7 34.3 4.1 34.3 1.7 0 5.1 4 5.1 5.6s3.7 6.7 8.8 12c3.5 3.6 6.3 13.7 7.7 20.4 .2 .8 0 1.6-.5 2.2s-1.2 1-2 .9l-55.6 0c-.9 0-1.7-.4-2.2-1.1s-.6-1.6-.4-2.4l8.1-24.4c.2-.6 .5-1 1-1.4l3.3-2.2c.7-.5 1.1-1.2 1.2-2 .7-6.5 3.4-10.2 5.5-11.9 .9-.7 1.5-1.7 1.6-2.8 .1-6.5 1.8-19 3-26.9 .1-.8-.1-1.5-.6-2.1s-1.2-.9-2-.9l-6.3 0c-2.9 0-5.3-2.4-5.3-5.3l-.7-62.3c0-1.5-1.3-2.8-2.9-3-4.8-.8-10.8-3.8-13.8-5.8-.2-.1-.3-.1-.5-.1s-.3 .2-.3 .4c-6.1 28.1-26.8 49.6-38 58.2-1.1 .9-2.6 1.2-4.1 .8-8.1-2.2-11-7.1-11.5-10-.1-.6 0-1.2 .2-1.8 12.1-36.1 31.2-49.7 40.3-56.2 1.2-.8 2.1-1.5 2.9-2.1 4.4-3.4 7.5-3.5 9.6-2.6 1.2 .5 2.7 .7 3.8-.1l13.4-10.1 0-14.9c0-2.9 2.4-5.3 5.3-5.3l3.2 0 0-4.5c0-.7-.3-1.4-.8-1.9s-1.2-.8-1.9-.8l-65.1 0c-1.2 0-2.3-.9-2.6-2.1l-13.5-60.5c-.5-2.4-2.7-4.2-5.2-4.2l-18.9 0c-2.9 0-5.3-2.4-5.3-5.3l0-69.3c0-2.8 2.1-5.1 4.9-5.3L97.8 158c2.1-.2 4-1.6 4.6-3.6L125.8 84c.7-2.2 2.8-3.7 5.1-3.7zm49.5 173c27.3 0 49.4-24.7 49.4-55.3s-22.1-55.3-49.4-55.3c-27.3 0-49.4 24.7-49.4 55.3s22.1 55.3 49.4 55.3zm145.7 0c27.3 0 49.4-24.7 49.4-55.3s-22.1-55.3-49.4-55.3c-27.3 0-49.4 24.7-49.4 55.3s22.1 55.3 49.4 55.3zm-81.4-4.6c-.1-.7-.7-1.2-1.4-1.1s-1.2 .6-1.3 1.3c.6 9.5 6.8 14.5 13.3 14.5s12.8-5 13.4-14.5c.1-.5-.1-1-.5-1.3s-1-.3-1.4-.1-.7 .7-.7 1.2c-.5 8.2-5.7 12-10.7 12-5 0-10.2-3.8-10.7-11.9zm81.4-54.6c-8.1 0-14.7-6.9-14.7-15.5s6.6-15.5 14.7-15.5 14.7 7 14.7 15.5c0 8.6-6.6 15.5-14.7 15.5zm.8-11.7c3.8 0 6.9-3.3 6.9-7.5 0-4.1-3.1-7.5-6.9-7.5-3.8 0-6.9 3.3-6.9 7.5 0 4.1 3.1 7.5 6.9 7.5zM183 194.6c-8.1 0-14.7-6.9-14.7-15.5s6.6-15.5 14.7-15.5 14.7 7 14.7 15.5c0 8.6-6.6 15.5-14.7 15.5zm.8-11.7c3.8 0 6.9-3.3 6.9-7.5 0-4.1-3.1-7.5-6.9-7.5s-7 3.3-7 7.5c0 4.1 3.1 7.5 7 7.5z'
      
    ]
  };

  

  
  

  var faCheckSlash = {
    prefix: 'fak',
    iconName: 'check-slash',
    icon: [
      550,
      512,
      [],
      'e000',
      
      'M477.9 17.3C490.7-.2 515.2-4.2 532.7 8.6l-.1 .1c17.5 12.7 21.4 37.2 8.7 54.8L360.4 312.1 522.9 474.6c8.3 8.3 8.3 21.8 0 30s-21.8 8.3-30 0L335.2 346.9 227.7 494.6c-6.7 9.3-17.1 15.1-28.7 16s-22.7-3.3-30.7-11.4L11.5 342.5c-15.3-15.3-15.3-40.2 0-55.5s40.2-15.3 55.5 0L191.3 411.3 279 290.7 25.8 37.5c-8.2-8.3-8.2-21.8 0-30.1 8.3-8.3 21.8-8.3 30 0L304.3 256 477.9 17.3z'
      
    ]
  };

  

  
  

  var faChevronsLeftChevronsRight = {
    prefix: 'fak',
    iconName: 'chevrons-left-chevrons-right',
    icon: [
      1168,
      512,
      [],
      'e012',
      
      'M230 10.7c14.3-14.3 37.5-14.3 51.8 0s14.3 37.5 0 51.8L88.3 256 281.9 449.5c14.3 14.3 14.3 37.5 0 51.8s-37.5 14.3-51.8 0L10.7 281.9c-14.3-14.3-14.3-37.5 0-51.8l-.1-.1 219.4-219.4zm219.4 0c14.3-14.3 37.5-14.3 51.8 0s14.3 37.5 0 51.8L307.7 256 501.3 449.5c14.3 14.3 14.3 37.5 0 51.8s-37.5 14.3-51.8 0L230.1 281.9c-14.3-14.3-14.3-37.5 0-51.8l219.4-219.4-.1-.1zm216.7 2.2c14.2-14.2 37.3-14.2 51.5 0L936.1 231.3c14.2 14.2 14.2 37.3 0 51.5l-218.4 218.4 .1 .1c-14.2 14.2-37.3 14.2-51.5 0s-14.2-37.3 0-51.5L858.9 257.1 666.1 64.5c-14.2-14.2-14.2-37.3 0-51.5zm218.4 0c14.2-14.2 37.3-14.2 51.5 0l218.4 218.4c14.2 14.2 14.2 37.3 0 51.5l.1 .1-218.4 218.4c-14.2 14.2-37.3 14.2-51.5 0s-14.2-37.3 0-51.5L1077.3 257.1 884.6 64.5c-14.2-14.2-14.2-37.3 0-51.5z'
      
    ]
  };

  

  
  

  var faCircleCheckSlash = {
    prefix: 'fak',
    iconName: 'circle-check-slash',
    icon: [
      512,
      512,
      [],
      'e010',
      
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM147.9 249.1c-8-7.9-20.9-7.9-28.9 0-3.8 3.8-6 9-6 14.3s2.2 10.5 6 14.4l81.7 81.2c8 7.9 20.9 7.9 28.9 0l50.5-50.2-29.7-28-35.3 35.1-67.2-66.8zM393 167.9c-8-7.9-20.9-7.9-28.9 0l-69 68.6-72.1-68.2c-9-8.3-22.9-8.3-31.9 0-4.2 3.9-6.6 9.4-6.6 15.1s2.4 11.2 6.6 15.1C279.4 282 238.2 243 311.3 312.1l49.2 46.6c9 8.3 22.9 8.3 31.9 0 4.2-3.9 6.6-9.4 6.6-15.1s-2.4-11.2-6.6-15.1l-67.7-63.9 68.3-67.9c3.8-3.8 6-9 6-14.3s-2.2-10.5-6-14.4l.1 0z'
      
    ]
  };

  

  
  

  var faCircleEye = {
    prefix: 'fak',
    iconName: 'circle-eye',
    icon: [
      512,
      512,
      [],
      'e00e',
      
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm.5-365c-39.1 0-70.5 17.8-93.3 39-22.7 21.1-37.8 46.2-45 63.5-1.6 3.8-1.6 8.1 0 11.9 7.2 17.3 22.4 42.5 45 63.5 22.8 21.2 54.1 39 93.3 39s70.5-17.8 93.3-39c22.7-21.1 37.8-46.2 45-63.5 1.6-3.8 1.6-8.1 0-11.9-7.2-17.3-22.4-42.5-45-63.5-22.8-21.2-54.1-39-93.3-39zm-1 179.3a70.3 70.3 0 1 1 1-140.5 70.3 70.3 0 1 1 -1 140.5zm45.9-82.8c-5.9-22.1-26.9-36.2-49-34.3 2.6 4.5 4.1 9.7 4.1 15.4 0 17.1-13.9 31-31 31-5.6 0-10.8-1.5-15.4-4.1-.5 5.3 0 10.7 1.4 16.1 6.6 24.8 32.2 39.5 56.9 32.9s39.5-32.2 32.9-57z'
      
    ]
  };

  

  
  

  var faCircleEyePen = {
    prefix: 'fak',
    iconName: 'circle-eye-pen',
    icon: [
      512,
      512,
      [],
      'e00f',
      
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM227.8 357.9c-5.6 5.6-9.7 12.6-11.8 20.3l-18.5 66.9c-1.2 4.3 0 9.1 3.2 12.2s7.9 4.4 12.2 3.2L279.9 442c7.6-2.1 14.6-6.2 20.3-11.8l112.5-112.6-72.2-72.2-112.7 112.6zM408.5 193c-10.1 0-19.7 4-26.7 11.1l-23.5 23.5 72.2 72.2 23.5-23.5c7.1-7.1 11.1-16.7 11.1-26.7s-4-19.7-11.1-26.7l-18.7-18.7c-7.1-7.1-16.7-11.1-26.7-11.1zM197.5 82c-37.4 0-67.4 17.1-89.3 37.4-21.7 20.2-36.2 44.3-43.1 60.9-1.5 3.7-1.5 7.8 0 11.4 6.9 16.6 21.4 40.7 43.1 60.9 21.8 20.3 51.8 37.4 89.3 37.4s67.4-17.1 89.3-37.4c21.7-20.2 36.2-44.3 43.1-60.9 1.5-3.7 1.5-7.8 0-11.4-6.9-16.6-21.4-40.7-43.1-60.9-21.8-20.3-51.8-37.4-89.3-37.4zm0 170.9a66.9 66.9 0 1 1 0-133.7 66.9 66.9 0 1 1 0 133.7zm43-78.4c-5.7-21.2-25.7-34.7-46.9-32.9 2.5 4.3 3.9 9.3 3.9 14.7 0 16.4-13.3 29.7-29.7 29.7-5.3 0-10.3-1.4-14.7-3.9-.5 5.1 0 10.3 1.3 15.4 6.3 23.8 30.8 37.9 54.5 31.5s37.8-30.8 31.5-54.6z'
      
    ]
  };

  

  
  

  var faCircleListCheck = {
    prefix: 'fak',
    iconName: 'circle-list-check',
    icon: [
      512,
      512,
      [],
      'e00c',
      
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM161.5 320.6a19.7 19.7 0 1 0 0 39.4 19.7 19.7 0 1 0 0-39.4zm63 3.9c-8.7 0-15.7 7-15.7 15.8s7 15.8 15.7 15.8l141.7 0c8.7 0 15.7-7 15.7-15.8s-7-15.8-15.7-15.8l-141.7 0zm-28.7-92.5c-5.3-3.7-12.7-2.5-16.4 2.9l-19.5 27.9-9.7-9.8c-4.6-4.6-12.1-4.6-16.7 0s-4.6 12.1 0 16.7l19.7 19.7c2.5 2.5 5.9 3.6 9.4 3.4s6.6-2.1 8.7-5l27.6-39.4c3.7-5.3 2.5-12.7-2.9-16.5l0 0zM256 245.7c-8.7 0-15.7 7-15.7 15.8s7 15.8 15.7 15.8l110.2 0c8.7 0 15.7-7 15.7-15.8s-7-15.8-15.7-15.8l-110.2 0zm-60.1-92.5c-5.3-3.7-12.7-2.5-16.4 2.9l-19.5 27.9-9.7-9.8c-4.6-4.6-12.2-4.6-16.7 0s-4.6 12.1 0 16.8l19.7 19.7c2.5 2.5 5.9 3.6 9.4 3.4s6.6-2.1 8.7-5l27.6-39.4c3.7-5.3 2.5-12.7-2.9-16.5zM256 166.8c-8.7 0-15.7 7-15.7 15.8s7 15.8 15.7 15.8l110.2 0c8.7 0 15.7-7 15.7-15.8s-7-15.8-15.7-15.8l-110.2 0z'
      
    ]
  };

  

  
  

  var faCircleMagnifyingGlass = {
    prefix: 'fak',
    iconName: 'circle-magnifying-glass',
    icon: [
      512,
      512,
      [],
      'e00d',
      
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM238 166c-43.1 0-78 34.9-78 78s34.9 78 78 78c17.2 0 33.1-5.6 46-15l47.5 47.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L301 290c9.4-12.9 15-28.8 15-46 0-43.1-34.9-78-78-78zm0 132a54 54 0 1 1 0-108 54 54 0 1 1 0 108z'
      
    ]
  };

  

  
  

  var faDocumentMedia = {
    prefix: 'fak',
    iconName: 'document-media',
    icon: [
      598,
      512,
      [],
      'e009',
      
      'M273.8 416c13.7 0 24.9 11.5 24.9 25.6l0 12.8c0 14.1-11.1 25.6-24.9 25.6L24.9 480C11.1 480 0 468.5 0 454.4l0-12.8C0 427.5 11.1 416 24.9 416l248.9 0zm298.7 0c13.7 0 24.9 11.5 24.9 25.6l0 12.8c0 14.1-11.1 25.6-24.9 25.6l-199.1 0c-13.7 0-24.9-11.5-24.9-25.6l0-12.8c0-14.1 11.1-25.6 24.9-25.6l199.1 0zm0-128c13.7 0 24.9 11.5 24.9 25.6l0 12.8c0 14.1-11.1 25.6-24.9 25.6l-199.1 0c-13.7 0-24.9-11.5-24.9-25.6l0-12.8c0-14.1 11.1-25.6 24.9-25.6l199.1 0zM248.9 32c27.5 0 49.8 22.9 49.8 51.2l0 204.8c0 28.3-22.3 51.2-49.8 51.2l-199.1 0C22.3 339.2 0 316.3 0 288L0 83.2C0 54.9 22.3 32 49.8 32l199.1 0zM62.2 275.2l174.2 0 0-179.2-174.2 0 0 179.2zM572.5 160c13.7 0 24.9 11.5 24.9 25.6l0 12.8c0 14.1-11.1 25.6-24.9 25.6l-199.1 0c-13.7 0-24.9-11.5-24.9-25.6l0-12.8c0-14.1 11.1-25.6 24.9-25.6l199.1 0zm0-128c13.7 0 24.9 11.5 24.9 25.6l0 12.8c0 14.1-11.1 25.6-24.9 25.6L373.3 96c-13.7 0-24.9-11.5-24.9-25.6l0-12.8c0-14.1 11.1-25.6 24.9-25.6l199.1 0z'
      
    ]
  };

  

  
  

  var faDocumentStar = {
    prefix: 'fak',
    iconName: 'document-star',
    icon: [
      652,
      512,
      [],
      'e00a',
      
      'M298.7 418.9c16.3 0 27.1 11.2 27.1 28l0 14c0 16.7-10.9 27.9-27.1 27.9l-271.5 0C10.9 488.7 0 477.6 0 460.8l0-14c0-16.8 10.9-27.9 27.1-28l271.5 0zm325.8 0c16.3 0 27.1 11.2 27.1 28l0 14c0 16.7-10.8 27.9-27.1 27.9l-217.2 0c-16.3 0-27.1-11.2-27.1-27.9l0-14c0-16.8 10.9-27.9 27.1-28l217.2 0zM179.2 0c5.4 0 8.1 2.8 10.8 8.4L239 108.9 347.5 125.7c8.1 0 10.9 5.6 10.9 11.2 0 5.6-2.7 8.4-5.4 11.1l-76 78.2 19 108.9 0 11.2c-.2 .2-2.8 2.8-5.4 2.8-2.7 0-5.5 0-8.2-2.8l-8.1 0-95-50.3-95 50.3c-2.7 0-5.4 0-8.1 2.8-2.7 0-5.4 0-5.5-2.8l0-11.2 19-108.9-84.2-81c-2.7-5.6-5.4-8.4-5.4-11.2 0-5.6 5.4-8.4 10.9-11.2l108.6-16.7 48.9-97.8c2.7-5.6 5.4-8.4 10.9-8.4zM624.5 279.3c16.3 0 27.1 11.2 27.1 27.9l0 14c0 16.7-10.8 27.9-27.1 27.9l-217.2 0c-16.3 0-27.1-11.2-27.1-27.9l0-14c0-16.7 10.9-27.9 27.1-27.9l217.2 0zm0-139.6c16.3 0 27.1 11.2 27.1 27.9l0 14c0 16.7-10.8 27.9-27.1 27.9l-217.2 0c-16.3 0-27.1-11.2-27.1-27.9l0-14c0-16.7 10.9-27.9 27.1-27.9l217.2 0zM624.5 0c16.3 0 27.1 11.2 27.1 27.9l0 14c0 16.8-10.8 28-27.1 28l-217.2 0c-16.3 0-27.1-11.2-27.1-28l0-14C380.1 11.2 391 0 407.3 0L624.5 0z'
      
    ]
  };

  

  
  

  var faEyePen = {
    prefix: 'fak',
    iconName: 'eye-pen',
    icon: [
      512,
      512,
      [],
      'e011',
      
      'M448.3 340.8L315.6 473.7c-6.7 6.7-14.9 11.4-23.9 14l-78.9 21.9c-5.1 1.4-10.6-.1-14.4-3.8s-5.2-9.3-3.8-14.4l21.9-78.9c2.5-9 7.3-17.3 14-23.9l132.9-132.8 85.2 85.2zm-4.9-146.9c11.9 0 23.2 4.7 31.6 13.1l22 22c8.4 8.3 13.1 19.7 13.1 31.6s-4.7 23.2-13.1 31.6l-27.7 27.7-85.2-85.2 27.7-27.7c8.3-8.4 19.7-13.1 31.6-13.1zM186.4 0c52.3 0 94.1 23.9 124.6 52.1 30.3 28.1 50.5 61.7 60.2 84.7 2.1 5.1 2.1 10.8 0 15.9-9.6 23.1-29.9 56.6-60.2 84.7-30.5 28.3-72.3 52.1-124.6 52.1S92.3 265.7 61.8 237.5C31.5 209.4 11.2 175.8 1.6 152.8-.5 147.6-.5 142 1.6 136.8 11.2 113.8 31.5 80.2 61.8 52.1 92.3 23.8 134.1 0 186.4 0zm0 51.7a93.1 93.1 0 1 0 0 186.2 93.1 93.1 0 1 0 0-186.2zM181 82.9c29.5-2.6 57.5 16.2 65.4 45.8 8.9 33.1-10.8 67.2-43.9 76s-67.2-10.8-76.1-43.9c-1.9-7.2-2.5-14.4-1.9-21.5 6.1 3.5 13.1 5.4 20.5 5.4 22.8 0 41.4-18.6 41.4-41.4 0-7.5-2-14.5-5.4-20.5z'
      
    ]
  };

  

  
  

  var faSpellcheckSuggest = {
    prefix: 'fak',
    iconName: 'spellcheck-suggest',
    icon: [
      631,
      512,
      [],
      'e001',
      
      'M441.8 479c-6.2 .1-12.1-2.3-16.5-6.6s-6.8-10.3-6.7-16.5l0-97.5-98.5 0c-5.9 0-11.6-2.4-15.8-6.7-4.2-4.5-6.5-10.3-6.6-16.5l0-45.4c.1-12.3 10-22.2 22.3-22.3l98.5 0 0-98.5c-.1-6 2.3-11.7 6.7-15.8 4.2-4.6 10.3-7.1 16.5-6.6l44.6 0c6.2-.5 12.4 1.9 16.6 6.6 4.3 4.1 6.7 9.8 6.6 15.8l0 98.5 98.5 0c12.3 .1 22.2 10 22.3 22.3l0 45.4c-.1 6.1-2.4 12-6.6 16.5-4.2 4.2-9.8 6.6-15.8 6.7l-98.5 0 0 97.5c.2 6.2-2.2 12.1-6.6 16.5s-10.3 6.8-16.5 6.6zM240.6 213.9c-7.1 0-13.9-2.8-18.9-7.8s-7.8-11.8-7.8-18.9l0-160.5c0-14.8 12-26.7 26.7-26.7l53.5 0c37 0 67 30 67 67 .1 11-2.7 21.8-7.9 31.5 20.2 18.7 26.8 47.8 16.7 73.4s-34.8 42.3-62.3 42.2zm26.7-53.4l40.1 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-40.1 0zm0-80.3l26.7 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-26.7 0zM135.7 197.5l-4.3-10.3-75.7 0-4.4 10.3c-5.7 13.6-21.3 20-35 14.4s-20-21.3-14.4-35L13.2 150.2 68.9 16.3C73 6.3 82.8-.2 93.5-.2S114 6.3 118.2 16.3l55.8 133.9 11.1 26.7c5.7 13.6-.7 29.3-14.4 35s-29.3-.7-35-14.4zM77.9 133.7l31.2 0-15.8-37.4z'
      
    ]
  };

  

  
  

  var faSubscript2 = {
    prefix: 'fak',
    iconName: 'subscript-2',
    icon: [
      615,
      512,
      [],
      'e006',
      
      'M423 458.7c-16.4 8.4-34.7 12.3-53.1 11.3-16.8 .9-33.2-4.9-45.7-16.1-12.7-14.5-18.8-33.5-17-52.7-18.8 23.3-43.2 41.4-71 52.7-27.9 10.9-57.5 16.3-87.4 16.1-19.5 .1-39-2.2-57.9-7-17.1-4.1-33.2-11.5-47.4-21.8-13.6-10.1-24.5-23.4-31.8-38.7-8.3-18.1-12.3-37.9-11.7-57.9-.9-21.7 3.6-43.2 13.1-62.7 8.2-15.7 20-29.3 34.4-39.6 14.8-10.4 31.3-18.3 48.7-23.1 18.3-5.2 37-9.6 56.3-13.1 20.5-4.1 39.8-7.1 57.9-9.2 16.3-1.7 32.5-4.6 48.3-8.7 12.2-2.9 23.5-8.5 33.1-16.5 8.5-8.3 13-19.9 12.2-31.8 .6-13.7-2.5-27.2-9.2-39.2-5.7-9.5-13.8-17.3-23.5-22.6-10-5.3-20.9-8.8-32.2-10.2-11.7-1.7-23.4-2.6-35.2-2.6-27.2-1-54.2 5.2-78.3 17.9-22.5 14.8-35.4 40.4-34 67.3l-74.1 0c.3-24.5 6.3-48.6 17.4-70.5 10-18.7 24.3-34.6 41.8-46.6 18.1-12.2 38.3-20.8 59.6-25.6 23.5-5.3 47.6-8 71.7-7.8 20.2 0 40.4 1.5 60.5 4.4 19.1 2.6 37.5 8.6 54.4 17.9 16.2 8.9 29.7 22 39.2 37.8 10.6 19.4 15.8 41.4 14.8 63.5l0 231.5c-.4 12.8 .6 25.7 3.1 38.3 2 8.1 8.8 12.2 20.5 12.2 7.7-.2 15.4-1.7 22.6-4.4zM302.9 228c-10.9 7.7-23.4 13-36.6 15.4-15.1 3.2-30.9 5.8-47.5 7.8s-33.2 4.4-50 7c-15.6 2.3-30.8 6.5-45.3 12.6-12.8 5.4-24 13.9-32.7 24.8-9.1 12.8-13.5 28.3-12.6 44-.3 10.7 2.3 21.3 7.4 30.7 4.7 8.2 11.3 15.2 19.1 20.5 8.3 5.4 17.6 9.3 27.4 11.3 10.9 2.4 22 3.5 33.1 3.5 21.3 .4 42.6-3 62.7-10.2 15.7-5.6 30.2-14.1 42.8-25 10.3-9.2 18.6-20.5 24.4-33.1 4.9-10.5 7.6-21.9 7.8-33.5zM566 434.8l-68.3 0 0 34.2 102.4 0 0 34.2-136.5 0 0-68.3c.1-18.8 15.3-34.1 34.2-34.2l68.2 0 0-34.1-102.4 0 0-34.2 102.4 0c18.8 .1 34.1 15.3 34.2 34.2l0 34.2c-.1 18.8-15.3 34-34.2 34.1z'
      
    ]
  };

  

  
  

  var faSuperscript2 = {
    prefix: 'fak',
    iconName: 'superscript-2',
    icon: [
      512,
      512,
      [],
      'e007',
      
      'M384.6 456.1c-14.9 7.6-31.6 11.2-48.3 10.3-15.2 .8-30.2-4.5-41.5-14.7-11.5-13.2-17.1-30.5-15.5-47.9-17.1 21.2-39.3 37.7-64.5 47.9-25.3 9.9-52.3 14.9-79.5 14.6-17.7 .1-35.4-2-52.6-6.3-15.5-3.7-30.2-10.4-43.1-19.8-12.3-9.2-22.3-21.3-28.9-35.2-7.5-16.5-11.2-34.5-10.7-52.6-.8-19.7 3.3-39.3 11.9-57 7.5-14.3 18.2-26.6 31.2-36 13.5-9.5 28.4-16.6 44.3-21 16.6-4.7 33.7-8.7 51.2-11.9 18.6-3.7 36.2-6.5 52.6-8.3 14.8-1.5 29.5-4.2 43.9-7.9 11.1-2.6 21.3-7.8 30.1-15 7.8-7.5 11.8-18.1 11.1-28.9 .6-12.4-2.3-24.7-8.3-35.6-5.2-8.6-12.6-15.7-21.4-20.6-9.1-4.8-19-8-29.3-9.3-10.6-1.6-21.3-2.4-32-2.4-24.7-.9-49.3 4.7-71.2 16.2-20.5 13.5-32.2 36.8-30.9 61.2l-67.4 0c.3-22.3 5.7-44.2 15.8-64.1 9.1-17 22.1-31.5 38-42.4 16.5-11.1 34.8-19 54.2-23.3 21.4-4.9 43.2-7.3 65.2-7.1 18.4 0 36.8 1.3 55 4 17.3 2.4 34.1 7.9 49.5 16.2 14.7 8.1 27 20 35.6 34.4 9.7 17.7 14.3 37.6 13.5 57.8l0 210.5c-.4 11.7 .6 23.4 2.8 34.8 1.8 7.4 8 11.1 18.6 11.1 7-.2 14-1.6 20.6-4zM275.4 246.4c-9.9 7-21.3 11.8-33.2 14-13.7 2.9-28.1 5.3-43.1 7.1s-30.2 4-45.5 6.3c-14.2 2.1-28 5.9-41.1 11.5-11.6 4.9-21.9 12.6-29.7 22.5-8.2 11.6-12.3 25.7-11.5 40-.3 9.7 2.1 19.4 6.7 27.9 4.3 7.5 10.2 13.8 17.4 18.6 7.6 4.9 16 8.4 24.9 10.3 9.9 2.2 20 3.2 30.1 3.2 19.4 .4 38.7-2.8 57-9.3 14.3-5.1 27.5-12.8 38.9-22.8 9.4-8.4 16.9-18.6 22.2-30.1 4.5-9.6 6.9-19.9 7.1-30.5zM477.6 93.1l-62.1 0 0 31 93.1 0 0 31-124.1 0 0-62.1c.1-17.1 13.9-31 31-31l62 0 0-31-93.1 0 0-31 93.1 0c17.1 .1 31 13.9 31 31l0 31c-.1 17.1-13.9 30.9-31 31z'
      
    ]
  };

  

  
  

  var faSuperscript3 = {
    prefix: 'fak',
    iconName: 'superscript-3',
    icon: [
      512,
      512,
      [],
      'e008',
      
      'M189 82.7c18.4 0 36.8 1.3 55 4 17.3 2.4 34.1 7.9 49.5 16.2 14.7 8.1 27 20 35.6 34.4 9.7 17.7 14.3 37.7 13.5 57.8l0 210.5c-.4 11.7 .6 23.4 2.8 34.8 1.8 7.4 8.1 11.1 18.6 11.1 7-.2 13.9-1.6 20.5-4l.1 52.2c-14.9 7.6-31.6 11.1-48.3 10.3-15.2 .8-30.1-4.5-41.5-14.7-5.7-6.5-10-14.1-12.7-22.3s-3.6-16.9-2.8-25.5c-17.1 21.2-39.3 37.6-64.5 47.9-25.3 9.9-52.3 14.9-79.5 14.6-17.7 .1-35.4-2-52.6-6.3-15.5-3.7-30.2-10.5-43.1-19.8-12.3-9.2-22.2-21.3-28.9-35.2-7.5-16.5-11.2-34.5-10.7-52.6-.8-19.7 3.3-39.3 11.9-57 7.5-14.3 18.2-26.6 31.2-36 13.5-9.5 28.5-16.6 44.3-21 16.6-4.7 33.7-8.7 51.2-11.9 18.6-3.7 36.2-6.5 52.6-8.3 14.8-1.5 29.5-4.2 43.9-7.9 11.1-2.6 21.4-7.8 30.1-15 3.8-3.7 6.8-8.2 8.7-13.2s2.7-10.3 2.4-15.7c.6-12.4-2.3-24.7-8.4-35.6-5.2-8.6-12.6-15.7-21.4-20.6-9.1-4.8-19-8-29.3-9.3-10.6-1.6-21.3-2.3-32-2.4-24.7-.9-49.3 4.8-71.2 16.3-10 6.6-18.2 15.7-23.6 26.5s-7.9 22.7-7.3 34.7l-67.4 0c.3-22.3 5.7-44.2 15.8-64.1 9.1-17 22.1-31.5 38-42.4 16.5-11.1 34.8-19 54.2-23.3 21.4-4.9 43.2-7.2 65.1-7.1zm86.4 207.2c-9.9 7-21.3 11.8-33.2 14-13.7 2.9-28.1 5.2-43.1 7.1s-30.2 4-45.5 6.4c-14.1 2.1-28 5.9-41.1 11.5-11.6 4.9-21.8 12.6-29.7 22.5-8.2 11.6-12.3 25.8-11.5 40-.3 9.7 2 19.4 6.7 27.9 4.3 7.5 10.2 13.9 17.4 18.6 7.6 4.9 16 8.4 24.9 10.3 9.9 2.2 20 3.2 30.1 3.2 19.4 .4 38.7-2.8 57-9.3 14.3-5.1 27.5-12.8 38.9-22.8 9.4-8.4 16.9-18.6 22.1-30 4.5-9.6 6.9-20 7.1-30.5l0-68.8zM508.6 18.6l-58.1 37.2 19.5 0c5.2-.1 10.4 .9 15.2 3s9.1 5.3 12.5 9.2c6.7 6.6 10.6 15.5 11 25l0 37.2c0 4.9-.9 9.8-2.9 14.4s-4.9 8.6-8.6 11.9c-3.6 3.5-7.8 6.3-12.5 8.2s-9.7 2.8-14.7 2.7l-39 0c-5 .3-10.1-.4-14.9-2.1s-9.1-4.4-12.7-7.9c-3.6-3.5-6.5-7.8-8.5-12.5s-2.8-9.7-2.7-14.8l19.5 0c-.2 2.5 .2 5.1 1.1 7.5s2.3 4.5 4.2 6.3 4 3.1 6.5 4 5 1.1 7.5 .9l19.5 0c2.5 0 5.1-.4 7.4-1.4s4.5-2.3 6.3-4.1c1.8-1.6 3.3-3.7 4.3-5.9s1.5-4.7 1.5-7.1l0-37.2c-.5-4.3-2.1-8.4-4.9-11.7-1.6-2.3-3.8-4.2-6.4-5.5s-5.4-1.8-8.2-1.6l-38.7 0 0-18.6 58.2-37.2-77.6 0 0-18.5 116.4 0 0 18.6z'
      
    ]
  };

  

  
  

  var faZattoo = {
    prefix: 'fak',
    iconName: 'zattoo',
    icon: [
      512,
      512,
      [],
      'e005',
      
      'M285.7 115c107.3 13 190.1 96.5 190.1 197.6 0 110.1-98.3 199.4-219.4 199.4-121.2 0-219.4-89.3-219.4-199.4 0-94.3 72.1-173.4 168.9-194.1l-56.7-68.4 13.1-10.5 62.7 75.6c10.3-1.3 20.7-2 31.4-2 3.1 0 6.1 .1 9.2 .2L354.3 0 367.6 10.2 285.7 115zm39.4 303.9c27.5-2.2 38.5-11.5 44.1-37 6.9-34.7 8-80.6 4.5-120.5-.9-10.4-2.1-20.1-3.7-28.9-3.3-19.8-20.2-33.4-38.1-34.9-69.8-5.9-159.9 11.3-195 24-15.8 5.2-25.6 18-28.7 34-5.3 36.3-3.4 81.7 2.2 109.4 5 21.6 17.2 30.4 32.5 34.9 11.5 3.3 19.8 5.5 34.2 8.3 37.5 7.6 102.2 14.2 147.9 10.7z'
      
    ]
  };

  



export {

  faBernand,
  

  faCheckSlash,
  

  faChevronsLeftChevronsRight,
  

  faCircleCheckSlash,
  

  faCircleEye,
  

  faCircleEyePen,
  

  faCircleListCheck,
  

  faCircleMagnifyingGlass,
  

  faDocumentMedia,
  

  faDocumentStar,
  

  faEyePen,
  

  faSpellcheckSuggest,
  

  faSubscript2,
  

  faSuperscript2,
  

  faSuperscript3,
  

  faZattoo,
  

};
